import React from 'react';

const FundingReportChartCard = ({ title, subtitle, children }) => (
  <div className="rounded-2xl border border-[var(--fg-line)] bg-[var(--fg-panel-soft)] p-4">
    <div className="mb-4">
      <div className="text-sm font-semibold text-[var(--fg-text)]">{title}</div>
      {subtitle ? <div className="text-xs text-[var(--fg-muted)]">{subtitle}</div> : null}
    </div>
    {children}
  </div>
);

const BarRow = ({ label, value, max }) => {
  const pct = max > 0 ? Math.round((value / max) * 100) : 0;
  return (
    <div className="space-y-1">
      <div className="flex items-center justify-between text-xs">
        <span className="text-[var(--fg-muted)]">{label}</span>
        <span className="font-medium text-[var(--fg-text)]">{value}</span>
      </div>
      <div className="h-2 overflow-hidden rounded-full bg-white dark:bg-slate-950/30">
        <div className="h-full rounded-full bg-[var(--fg-accent)]" style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
};

export const FundingReportBarChart = ({ items = [], valueKey = 'value', labelKey = 'label' }) => {
  const max = Math.max(...items.map((item) => Number(item[valueKey]) || 0), 1);
  return (
    <div className="space-y-3">
      {items.length === 0 ? (
        <p className="text-sm text-[var(--fg-muted)]">No data for this report range.</p>
      ) : (
        items.map((item) => (
          <BarRow
            key={item[labelKey]}
            label={item[labelKey]}
            value={item[valueKey]}
            max={max}
          />
        ))
      )}
    </div>
  );
};

export default FundingReportChartCard;
